"use strict";

import "bootstrap";
import {Header} from "/scripts/components/Header.js";

const header = new Header();

window.addEventListener("scroll", () => {
    requestAnimationFrame(header.handleScroll);
});

window.addEventListener("resize", () => {
    requestAnimationFrame(header.handleResize);
});
